import { render } from "./InlineActionDropdown.vue?vue&type=template&id=b8b93bba"
import script from "./InlineActionDropdown.vue?vue&type=script&lang=js"
export * from "./InlineActionDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__